export const facilities = [
  {
    id: "smart-classrooms",
    title: "Smart Classrooms",
    iconName: "Monitor",
    color: "#E0F2FE",
    iconColor: "#0284c7",
    desc: "Interactive, colorful, well-organized classrooms designed for engaging, visual, and age-appropriate learning."
  },
  {
    id: "cctv-security",
    title: "CCTV Security",
    iconName: "ShieldCheck",
    color: "#FDE8E9",
    iconColor: "#C8161D",
    desc: "Comprehensive campus monitoring and safety processes that help provide parents with complete peace of mind."
  },
  {
    id: "play-areas",
    title: "Indoor & Outdoor Play Areas",
    iconName: "Dumbbell",
    color: "#F3F9E2",
    iconColor: "#9DC41E",
    desc: "Safe play zones designed to support physical movement, coordination, teamwork, and active exploration."
  },
  {
    id: "activity-rooms",
    title: "Activity Rooms",
    iconName: "Palette",
    color: "#FCE7F3",
    iconColor: "#DB2777",
    desc: "Dedicated spaces for art, dance, music, storytelling, role-play, and creative self-expression."
  },
  {
    id: "child-infrastructure",
    title: "Child-Friendly Infrastructure",
    iconName: "Sparkles",
    color: "#FEF9C3",
    iconColor: "#ca8a04",
    desc: "Rounded furniture, accessible spaces, child-safe fittings, and facilities created especially for young learners."
  },
  {
    id: "transportation",
    title: "Transportation Facility",
    iconName: "Bus",
    color: "#E0F2FE",
    iconColor: "#0284c7",
    desc: "Safe and reliable school vans/buses with trained drivers and support staff, subject to route availability."
  },
  {
    id: "hygiene",
    title: "Hygiene & Cleanliness",
    iconName: "Heart",
    color: "#F3F9E2",
    iconColor: "#9DC41E",
    desc: "Regular cleaning, child-friendly washrooms, clean drinking water, and age-appropriate personal hygiene guidance."
  },
  {
    id: "learning-resources",
    title: "Learning Resources",
    iconName: "BookOpen",
    color: "#FEF9C3",
    iconColor: "#ca8a04",
    desc: "Safe, non-toxic educational toys, puzzles, library books, and sensory play materials."
  }
];

export const safetyCommitments = [
  "Visitor management process at school gate",
  "Continuous CCTV monitoring in classrooms & play zones",
  "Constant teacher & maid supervision of all children",
  "Secure child handover process (only to authorized guardians)",
  "Daily cleaning and sanitization of toys & learning materials",
  "Trained support staff in school transport vans",
  "First-aid kits available on campus and in school transport",
  "Fire extinguishers installed & staff trained in emergencies"
];
